import { defineOnboardingSection } from "onboarding/utils";

const orderedSteps = ["Install", "Data"];

export const HOST_TRACK = defineOnboardingSection({
  orderedSteps,
  prefix: "Host ",
  sectionName: "host",
  steps: orderedSteps.concat(["Invite", "Complete"]),
});
export default HOST_TRACK;
